import { DialogTitle, DialogTitleProps, Theme, Palette, PaletteColor } from '@mui/material';
import { styled } from '@mui/styles';
interface Props {
  theme: Theme;
  backgroundColor: keyof Palette;
}

export const PmiDialogTitle = styled((props: DialogTitleProps) => <DialogTitle {...props} />)(
  ({ theme, backgroundColor }: Props) => ({
    backgroundColor: (theme.palette[backgroundColor] as PaletteColor).main,
    padding: '8px 24px !important',
  })
);
